(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {

    const items = document.querySelectorAll('.faq-item');

    items.forEach(item => {

        const button = item.querySelector('.faq-question');

        button.addEventListener('click', () => {

            const isActive = item.classList.contains('active');

            items.forEach(other => {

                other.classList.remove('active');

            });

            if (!isActive) {

                item.classList.add('active');

            }

        });

    });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
